import React from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import WorkplaceCalendar from '../../../../Components/Calendar/WorkplaceCalendar';

interface Props {
	patientId?: string;
}

const CalendarNewEventDetail: React.FC<Props> = ({ patientId }) => {
	const { workplaceId } = useAppContext();

	return (
		<WorkplaceCalendar
			workplaceId={workplaceId}
			patientId={patientId}
			params={{ createNewEvent: true }}
		/>
	);
};

export default CalendarNewEventDetail;
